/* ---------- product image thumbs ---------- */
$(".prod_images-thumbs").on("click", function () {
  $(".is-active").removeClass("is-active");
  $(this).addClass("is-active");
  let myIndex = $(this).index();
  $(".prod_image").eq(myIndex).addClass("is-active");
});

/* ---------- buy page extras ---------- */
document.addEventListener('DOMContentLoaded', function() {
  // Pobieramy wszystkie przyciski zakładek
  const tabs = document.querySelectorAll('.prod_tab');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // 1. Sprawdzamy, jaki kolor został kliknięty (np. "Black")
      const colorValue = this.getAttribute('data-w-tab');
      
      // 2. Szukamy wszystkich innych zakładek z tym samym kolorem
      const twinTabs = document.querySelectorAll(`.prod_tab[data-w-tab="${colorValue}"]`);

      twinTabs.forEach(twin => {
        // 3. Klikamy w bliźniaczą zakładkę tylko wtedy, 
        // jeśli nie jest to ta sama, którą właśnie kliknęliśmy,
        // oraz jeśli nie jest ona jeszcze aktywna (żeby uniknąć pętli)
        if (twin !== this && !twin.classList.contains('w--current')) {
          twin.click();
        }
      });
    });
  });
});
